import { useEffect } from 'react';

import brandLogo from '../brand-logo.png';

const LANDING_FONT_STYLESHEET_ID = 'agentic-blue-auth-landing-fonts';
const LANDING_FONT_STYLESHEET_HREF =
  'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@700&display=swap';

const WORKFLOW_STEPS = [
  {
    number: '01',
    title: 'Runtime evidence review',
    description: 'Upload traces and see which workflows have enough evidence to review safely.',
  },
  {
    number: '02',
    title: 'Prioritized findings',
    description: 'Focus on the riskiest reliability signals before drilling into technical detail.',
  },
  {
    number: '03',
    title: 'Validation and proof',
    description: 'Track the intended fix, attach validation, and compare follow-up evidence without overstating proof.',
  },
];

export default function AuthLandingView({ loginHref, noMembership = false, message = '' }) {
  useEffect(() => {
    if (document.getElementById(LANDING_FONT_STYLESHEET_ID)) {
      return;
    }
    const stylesheet = document.createElement('link');
    stylesheet.id = LANDING_FONT_STYLESHEET_ID;
    stylesheet.rel = 'stylesheet';
    stylesheet.href = LANDING_FONT_STYLESHEET_HREF;
    document.head.appendChild(stylesheet);
  }, []);

  const statusCopy = noMembership
    ? message ||
      'You are signed in, but no Runtime Intelligence tenant is available yet. Contact Agentic Blue to create your workspace.'
    : message || 'Tenant-scoped runtime evidence · Workspace-only access';

  return (
    <main className="auth-landing">
      <div className="auth-landing-layout">
        <section className="auth-landing-card" aria-label="Runtime Intelligence sign in">
          <div className="auth-landing-primary">
            <div className="auth-product-lockup">
              <img className="auth-product-logo" src={brandLogo} alt="Agentic Blue" />
              <div>
                <p className="auth-product-eyebrow">Agentic Blue</p>
                <p className="auth-product-name">Runtime Intelligence</p>
              </div>
            </div>
            <h1>
              Turn runtime traces into <span>improvement proof</span>
            </h1>
            <p className="auth-landing-copy">
              Find risky workflow behavior, decide what to validate next, and compare follow-up evidence without overstating the claim.
            </p>
            {!noMembership ? (
              <a className="auth-primary-action" href={loginHref}>
                Sign in to workspace <span aria-hidden="true">→</span>
              </a>
            ) : null}
            <p className="auth-landing-note">{statusCopy}</p>
          </div>
        </section>

        <section className="auth-workflow-panel" aria-label="Runtime review workflow">
          <div className="auth-workflow-header">
            <p className="auth-section-kicker">Runtime review workflow</p>
            <p>From evidence to prioritized action and proof-backed follow-up.</p>
          </div>
          <div className="auth-workflow-list">
            {WORKFLOW_STEPS.map((step) => (
              <article className="auth-workflow-step" key={step.number}>
                <span className="auth-workflow-number">{step.number}</span>
                <div>
                  <h2>{step.title}</h2>
                  <p>{step.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
